<template>
  <div class="report-tag-box">
    <div class="dot" />
    <img src="@/assets/image/btcinfo/cow.png" />
    <span>{{ getMonth(title) }}</span>
  </div>
</template>

<script>
export default {
  name: 'CnBTCInfoReportCard',
  props: {
    title: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getMonth (month) {
      switch (month) {
        case 1:
          return '一月'
        case 2:
          return '二月'
        case 3:
          return '三月'
        case 4:
          return '四月'
        case 5:
          return '五月'
        case 6:
          return '六月'
        case 7:
          return '七月'
        case 8:
          return '八月'
        case 9:
          return '九月'
        case 10:
          return '十月'
        case 11:
          return '十一月'
        case 12:
          return '十二月'
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$box_size: 40px;
$img_size: 30px;

.report-tag-box {
  height: $box_size;
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0 0 5px 2px #e0e0e0;
}
.report-tag-box > .dot {
  min-width: 12px;
  min-height: 12px;
  border-radius: 6px;
  background-color: #6bb37a;
  margin: 0 10px;
  transform: scale(.8);
}
.report-tag-box > img {
  width: $img_size;
  height: $img_size;
}
.report-tag-box > span {
  color: #e22229;
  font-weight: bold;
  margin: 0 20px;
}
</style>
